import { render, staticRenderFns } from "./FBT.vue?vue&type=template&id=4893bb67"
import script from "./FBT.vue?vue&type=script&lang=js"
export * from "./FBT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports